<template>
  <div class="h-mx-auto sm:min-h-screen">
    <router-view />
  </div>
</template>
    
<script setup>
</script>
  